import { BoundType, getBoundType } from './1d-bound-checker';

export interface BoundingBoxInfo {
  start: number;
  end: number;
  boundType: BoundType;
}

export const getBoundingBoxInfos = (elements: HTMLElement[], clientWidth: number, boundStart: number, boundEnd: number): BoundingBoxInfo[] => elements.map((el) => {
  const start = el.offsetLeft;
  const end = start + el.clientWidth;

  return {
    start,
    end,
    boundType: getBoundType(boundStart, boundEnd, start, end),
  };
});
